import Image from "next/image";
import style from "../../styles/preference.module.css";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
import React,{useState} from "react";

// Advantage grid component for Preference program page
const AdvantageGrid = ({
  image,
  heading,
  desc,
  widthManage,
  marginManage,
  count,
  hideImage,
  id,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hideImagevalue, setHideImagevalue] = useState(false);
  return (
    <div className={`${style.advantage_grid}  ${widthManage}`}>
      <div className={`${style.advantage_grid_img}  ${marginManage}`}>
        
        {!hideImage && (
          <>
          {/* {isLoading && !hideImagevalue && <Skeleton height={40} width={40} />} */}
          {!hideImagevalue && (
          <Image
            // src = "/assets/images/preference-program/calculator.svg"
            src={image}
            width={!isLoading?40:0}
            height={!isLoading?40:0}
            className={`${isLoading ? "hidden" : "block"}`}
            onLoad={() => setIsLoading(false)}
            onError={() => setHideImagevalue(true)}
          />
          )}
                </>
        )

        }

        {count && (
          <div className="advantage-count-wrapper text-center">
            <span className={style.advantage_count}>{count}</span>
          </div>
        )}
      </div>

      <div className="advantage-grid-content unreset">
        <h2 className={style.advantage_content}>{heading}</h2>
        <p
         className={`${style.advantage_desc} advantage-desc` }
          dangerouslySetInnerHTML={{ __html: desc }}
        ></p>
      </div>

      {id && <span className={style.advantage_id}>{id}</span>}
    </div>
  );
};

export default AdvantageGrid;
